import { motion } from 'framer-motion';
import Balancer from 'react-wrap-balancer';

import { fadeUp, revealOnView, stagger } from '@marketing/motion/variants';

// ============================================================
// ManifestoBlock — quote tipográfica + 3 parágrafos
// ============================================================

const paragraphs = [
  {
    title: 'Por que o Lume existe',
    body:
      'O deslocamento físico até hospitais e consultórios é uma barreira sensorial, financeira e familiar para muitas pessoas autistas. O Lume reduz essa barreira sem reduzir a qualidade do cuidado.',
  },
  {
    title: 'O que muda',
    body:
      'O uso natural do dispositivo — registrar humor, conversar com pictogramas, regular emoções — vira prontuário vivo. A IA atua como instrumento clínico do médico, jamais como companhia ou diagnosticadora.',
  },
  {
    title: 'Para quem',
    body:
      'Os três níveis de suporte (DSM-5-TR / CID-11 6A02.0–5), com interface adaptada por nível, sem fricção desnecessária, sem badges infantilizantes, com acessibilidade universal.',
  },
];

export function ManifestoBlock() {
  return (
    <section
      id="manifesto"
      className="lume-section"
      aria-labelledby="manifesto-title"
    >
      <div className="lume-container">
        <motion.div
          {...revealOnView}
          variants={stagger(0.12)}
          className="lume-stack lume-stack-lg"
        >
          <motion.p variants={fadeUp} className="lume-eyebrow">
            Manifesto
          </motion.p>

          <motion.blockquote variants={fadeUp} className="lume-manifesto" id="manifesto-title">
            <p className="lume-quote lume-text-balance">
              <Balancer>
                A pessoa autista é sujeito do cuidado, não objeto de monitoramento.
              </Balancer>
            </p>
            <footer
              style={{
                marginTop: '0.85rem',
                fontFamily: 'var(--font-display)',
                fontSize: '0.9rem',
                color: 'var(--color-fg-subtle)',
                letterSpacing: '0.02em',
              }}
            >
              Princípio 1 do Lume — Carta de Princípios do Programa
            </footer>
          </motion.blockquote>

          <div
            style={{
              display: 'grid',
              gap: 'clamp(1.25rem, 2.5vw, 2rem)',
              gridTemplateColumns: 'repeat(auto-fit, minmax(240px, 1fr))',
              marginTop: 'clamp(1rem, 3vw, 2.5rem)',
            }}
          >
            {paragraphs.map((p) => (
              <motion.div
                key={p.title}
                variants={fadeUp}
                className="lume-stack lume-stack-sm"
              >
                <h3 className="lume-h3" style={{ fontSize: '1.15rem' }}>{p.title}</h3>
                <p className="lume-text-pretty" style={{ color: 'var(--color-fg-muted)' }}>
                  {p.body}
                </p>
              </motion.div>
            ))}
          </div>
        </motion.div>
      </div>
    </section>
  );
}
